module.exports = function ClientFilterSubscribeRequest(filter, selector) {
    this.filter = filter;
    this.selector = selector;
};


//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/control-client/client-filter-subscribe-request.js
// module id = 302
// module chunks = 1